<div [class.is-printing]="printService.isPrinting">
    <form [formGroup]="form">
        <div class="modal-header">
            <h4 class="modal-title">Skilleblade</h4>
            <button (click)="clickedClose()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
        </div>

        <div class="modal-body">
            <div class="row g-3">
                <div class="col-md">
                    <div class="card card__border--solid me-0 ms-0 mb-2">

                        <div class="card-header">
                            <div class="row">
                                <div class="col">Stamarkiv</div>
                            </div>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            [checked]="stamarkiverAlle"
                                            (change)="clickedAlle('stamarkiver', $event.target.checked)"
                                            id="stamarkiverAlle">
                                        <label class="form-check-label" for="stamarkiverAlle">Alle</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col"><hr></div>
                            </div>
                            <div formGroupName="stamarkiver" class="form-check">
                                <div *ngFor="let stamarkiv of stamarkiver">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        [formControlName]="stamarkiv.id"
                                        [id]="stamarkiv.id">
                                    <label class="form-check-label" [for]="stamarkiv.id">{{stamarkiv.libname}}</label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="col-md">

                    <div class="card card__border--solid me-0 ms-0 mb-2">

                        <div class="card-header">
                            <div class="row">
                                <div class="col">Sager</div>
                            </div>
                        </div>

                        <div class="card-body">

                            <div class="row">
                                <div class="col-4">
                                    <div class="form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            [checked]="arbejdsarkiverAlle"
                                            (change)="clickedAlle('arbejdsarkiver', $event.target.checked)"
                                            id="arbejdsarkiverAlle">
                                        <label class="form-check-label" for="arbejdsarkiverAlle">Alle</label>
                                    </div>
                                </div>
                                <div class="col-8">
                                    <select class="form-select form-select-sm float-end" id="dropdownSag" formControlName="sag">
                                        <option disabled selected value="null"> -- Vælg sag -- </option>
                                        <option *ngFor="let c of casesSkilleblade" [ngValue]="c.pid">{{c.beskrivelse}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col"><hr></div>
                            </div>
                            <div formGroupName="arbejdsarkiver" class="form-check">
                                <div *ngFor="let arbejdsarkiv of arbejdsarkiver">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        [formControlName]="arbejdsarkiv.id"
                                        [id]="arbejdsarkiv.id">
                                    <label class="form-check-label" [for]="arbejdsarkiv.id">{{arbejdsarkiv.libname}}</label>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="btn-toolbar float-end mb-2">
                    <button (click)="clickedClose()" class="btn btn-primary me-2" type="button">Annuller</button>
                    <button (click)="clickedPrint()" class="btn btn-primary me-2" type="submit">Print</button>
            </div>
        </div>
    </form>
</div>
